import React from 'react';
import { LuCheck, LuCopy } from 'react-icons/lu';

interface CopyButtonProps {
  copied: boolean;
  onCopy: () => void;
  /** Overrides the resting label — e.g. Cashflow switches this to "Copy selection" while a range is selected, so one button's label always matches what it's about to copy. */
  label?: string;
}

/** Small "Copy to clipboard" pill — shared by every Summary 2 table. */
const CopyButton: React.FC<CopyButtonProps> = ({
  copied,
  onCopy,
  label = 'Copy to clipboard',
}) => (
  <button
    type="button"
    className="inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-transparent bg-transparent px-2.5 py-1 text-sm font-semibold text-charcoal transition-colors hover:border-charcoal hover:bg-rowHover"
    onClick={onCopy}
    title={label}
  >
    {copied ? <LuCheck size={14} /> : <LuCopy size={14} />}
    {copied ? 'Copied' : label}
  </button>
);

export default CopyButton;
